import { type PeriodOfTheDay, workScheduleBetweenItems } from '@omecare/utils';
import { formatPeriodHourRange } from '@/components/sheets/slot-sheet/format-slot-schedule';

/**
 * "Matin · 08:00 – 14:00" summary of a period of the day, used as the caption
 * of the selected-dates card so the hours the slots will span stay visible
 * while dates are being picked.
 *
 * @param params.periodOfTheDay - the period picked in the form
 * @param params.translate - the i18next translate function
 * @returns the composed label, or the bare period name when it has no range
 */
export const buildPeriodSummaryLabel = ({
  periodOfTheDay,
  translate,
}: {
  periodOfTheDay: PeriodOfTheDay;
  translate: (key: string) => string;
}): string => {
  const period = workScheduleBetweenItems.find(
    (item) => item.id === periodOfTheDay,
  );
  const name = translate(`period-of-day.${periodOfTheDay}`);
  const range = formatPeriodHourRange(period?.value ?? null);
  return range ? `${name} · ${range}` : name;
};
